module.exports = __webpack_public_path__ + "img/sg-android.810136c2.png";